import { Modal, Form, Input } from "antd";
import { postData } from "../../utils";
import { useBlockScreen, useRoot } from "../../rootContext";
import { useState } from "react";

const ResetPasswordModal = ({ visible, onClose, userName }) => {
    const [form] = Form.useForm();
    const blocker = useBlockScreen();
    const root = useRoot();
    const [submitting, setSubmitting] = useState(false);

    const handleOk = () => {
        form.validateFields().then(values => {
            setSubmitting(true);
            postData(
                window.SiteBasePath + "/api/auth/admin-reset-password",
                {
                    Username: userName,
                    NewPassword: values.NewPassword,
                    ConfirmPassword: values.ConfirmPassword
                },
                { blocker, root }
            )
                .then(() => {
                    alert("Password reset successfully.");
                    onClose();
                })
                .finally(() => setSubmitting(false));
        });
    };

    return (
        <Modal
            title={`Reset Password for ${userName}`}
            open={visible}
            onOk={handleOk}
            confirmLoading={submitting}
            onCancel={onClose}
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    name="NewPassword"
                    label="New Password"
                    rules={[{ required: true, message: "Please input new password!" }]}
                >
                    <Input.Password />
                </Form.Item>

                <Form.Item
                    name="ConfirmPassword"
                    label="Confirm Password"
                    rules={[{ required: true, message: "Please confirm password!" }]}
                >
                    <Input.Password />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default ResetPasswordModal;
